import React from 'react';

interface PauseIconProps {
    width?: number;
    height?: number;
    className?: string;
    style?: React.CSSProperties;
}

const PauseIcon: React.FC<PauseIconProps> = ({
    width = 24,
    height = 24,
    className = '',
    style = {}
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
            style={style}
        >
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
        </svg>
    );
};

export default PauseIcon;
